module.exports = __webpack_public_path__ + "static/media/the_lost_tribe_bg2.67fc8acc.jpg";